import { joiResolver } from '@hookform/resolvers/joi';
import Joi from 'joi';
import tlds from 'tlds';

export const EmailField = {
  email: Joi.string()
    .trim()
    .email({ tlds: { allow: tlds } })
    .required()
    .messages({ 'string.empty': 'Email is required', 'string.email': 'Email is not valid' }),
};

export const SearchField = {
  search: Joi.string().trim().allow(null, ''),
  category: Joi.string().trim().allow(null, ''),
};

export function createResolver<T>(schema: Record<keyof T, Joi.AnySchema>) {
  return joiResolver(Joi.object<T>(schema).unknown(), { abortEarly: false });
}

interface ArraySchema<T extends Joi.AnySchema = any> {
  items(type: T): ArraySchema<extractType<T>>;
}

type extractType<T extends Joi.SchemaLike> = T extends Joi.BooleanSchema
  ? boolean
  : T extends Joi.NumberSchema
    ? number
    : T extends Joi.StringSchema
      ? string
      : T extends Joi.ObjectSchema<infer O>
        ? { [K in keyof O]: O[K] extends Joi.SchemaLike ? extractType<O[K]> : object }
        : T extends ArraySchema
          ? any[]
          : any;

export type SchemaFields<T> = T extends Record<any, Joi.AnySchema> ? { [P in keyof T]: extractType<T[P]> } : never;
